module.exports = __webpack_public_path__ + "static/media/card-temp-Charile-mobile-inactive.53efce73.svg";